import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8aakdtj3we: FaireBrandEntity = {
  token: "b_8aakdtj3we",
  type: "brand",
  name: "Dubai Delights",
  avatarUrl:
    "https://cdn.faire.com/fastly/1909f8f910e897fb2ca416ec24cbc270345807ba66c9e0acad2856b58aa3491d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/790a7a8ac5068b3a1bfaada98bd25c6b623c7d4223abb173cacf12c86625ac2c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1909f8f910e897fb2ca416ec24cbc270345807ba66c9e0acad2856b58aa3491d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/790a7a8ac5068b3a1bfaada98bd25c6b623c7d4223abb173cacf12c86625ac2c.png",
  location: "Lincolnshire, IL, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 8,
  isInsider: true,
  description:
    "Dubai Delights was founded by three immigrants brought together by a shared love of food, culture, and the belief that some of the most meaningful connections are made through dessert. Drawing from their backgrounds and experiences, the brand was created to bring the richness of Middle Eastern flavors to modern specialty retail.\n\nInspired by the craftsmanship and hospitality of Dubai, we focus on indulgent chocolates made with premium ingredients and distinctive regional influences. Our signature kunafa bars combine smooth milk chocolate with layered fillings and traditional textures, delivering an elevated yet approachable experience.\n\nAt the heart of the brand is our Fusion Kunafa Bar (Triple Crown) — a three-flavor chocolate bar designed around discovery. Each bar features a curated trio of kunafa-inspired fillings, offering variety, balance, and a sense of exploration in a single, beautifully packaged product. This patchwork-inspired approach encourages trial, gifting, and repeat purchase.\n\nDubai Delights is crafted to perform across gifting, specialty food, cafés, and lifestyle retail. Authentically made in Dubai and shipped from the USA for fast, reliable fulfillment, our products are designed to stand out on shelf while remaining easy for retailers to merchandise and reorder.\n\nLuxury. Every Bite.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:09.092Z",
    importedBy: "entity-db-cli",
  },
};
